<template>
    <section class="c-fellow-slider">
        <div
            v-if="content"
            class="c-fellow-slider--loaded"
        >
            <div
                v-if="content"
                class="c-fellow-slider__title"
            >
                <h2 v-if="content.title">
                    {{ content.title }}
                </h2>
            </div>
            <div class="c-fellow-slider__content">
                <y-slideshow :content="content" />
            </div>
            <div
                v-if="content.button_title"
                class="c-fellow-slider__action"
            >
                <y-button
                    :tag="isLink(content.button_link) ? 'a' : 'router-link'"
                    :href="content.button_link"
                    :to="content.button_link"
                    :content="content.button_title"
                    color="primary"
                    size="medium"
                    flat
                    :no-padding="true"
                />
            </div>
        </div>
    </section>
</template>

<script >
    import { isLink } from '@/helpers/helpers';
    import YSlideshow from './Slideshow/Index.vue';

    export default {
        name: 'FellowDeveloperSlider',

        components: {
            YSlideshow,
        },

        props: {
            content: Object,
            default: String,

        },

        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,

        },
    };

</script>

<style lang="scss" src="./fellow-developers.scss"/>
